module.exports = __webpack_public_path__ + "static/media/Mantyke_gaussian2.6752e213.png";